module.exports = __webpack_public_path__ + "static/media/face-panic.02725a83.webp";